import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { IListInstituicao } from '../../interfaces/instituicao';

@Injectable()
export class OracaoProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  totalAdm: any = 0;
  public instituicaoFiltragem = null;

  constructor(public http: HttpClient) {}

  getOracoes(pag, meusPedidos, isTestemunho, idInstituicao) {
    return this.http
      .get<any>(this.baseUrl + '/oracao', {
        observe: 'response',
        params: {
          expand: 'total, userOrei',
          page: pag.currentPage,
          'per-page': '10',
          meusPedidos: meusPedidos,
          isTestemunho: isTestemunho,
          idInstituicao: idInstituicao,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
          totalPendente: data.headers.get('X-Count-Pedido-Oracao-Pendente'),
        };

        return {
          oracoes: data.body,
          pagination: pag,
        };
      });
  }

  getAdmOracoes(pag, filtro, isTestemunho) {
    return this.http
      .post<any>(this.baseUrl + '/oracao/adm-list', filtro, {
        observe: 'response',
        params: {
          expand: 'status,liberado,privacidade,idPessoa',
          page: pag.currentPage,
          'per-page': '5',
          isTestemunho: isTestemunho,
        },
      })
      .map((data) => {
        let pag = {
          currentPage: data.headers.get('X-Pagination-Current-Page'),
          pageCount: data.headers.get('X-Pagination-Page-Count'),
          perPage: data.headers.get('X-Pagination-Per-Page'),
          totalCount: data.headers.get('X-Pagination-Total-Count'),
        };
        return {
          oracoes: data.body,
          pagination: pag,
        };
      });
  }

  oreiPorVoce(oracao) {
    return this.http.post<any>(this.baseUrl + '/oracao/orei-por-voce', oracao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  getOracao(id) {
    return this.http.post<any>(this.baseUrl + '/oracao/get-oracao', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  setPrivacidade(idOracao, privacidade) {
    return this.http
      .post<any>(this.baseUrl + '/oracao/alterar-privacidade', {
        idOracao: idOracao,
        privacidade: privacidade,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  getResposta(id) {
    return this.http
      .get<any>(this.baseUrl + '/oracao/resposta', {
        params: {
          id: id,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data.resposta;
        } else {
          return false;
        }
      });
  }

  getAdminTotal() {
    return this.totalAdm;
  }

  getInicioOracaoAdmin() {
    return this.http.get<any>(this.baseUrl + '/oracao/get-nao-orados', {}).map((data) => {
      if (!data.error) {
        this.totalAdm = data;
        return data;
      } else {
        return false;
      }
    });
  }

  getPessoaOrando(id) {
    return this.http
      .get<any>(this.baseUrl + '/oracao/pessoas-orando', {
        params: {
          id: id,
        },
      })
      .map((data) => {
        if (!data.error) {
          return data.pessoas;
        } else {
          return false;
        }
      });
  }

  denunciar(oracao) {
    return this.http.post<any>(this.baseUrl + '/oracao/denunciar', oracao).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  excluir(id) {
    return this.http.post<any>(this.baseUrl + '/oracao/excluir', { id: id }).map((data) => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    });
  }

  criarOracao(pedido, publico = false, idOracao = 0, isTestemunho = '0', idPessoa = 0) {
    return this.http
      .post<any>(this.baseUrl + '/oracao', {
        pedido: pedido,
        publico: publico,
        idOracao: idOracao,
        isTestemunho: isTestemunho,
        idPessoa: idPessoa,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  setPublico(id, publico) {
    return this.http
      .post<any>(this.baseUrl + '/oracao/set-liberado', {
        id: id,
        liberado: publico,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  responder(id, liberado, resposta) {
    return this.http
      .post<any>(this.baseUrl + '/oracao/enviar-resposta', {
        id: id,
        liberado: liberado,
        resposta: resposta,
      })
      .map((data) => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      });
  }

  setInstituicaoFiltragem(instituicao) {
    this.instituicaoFiltragem = instituicao;
  }

  getInstituicaoFiltragem() {
    return this.instituicaoFiltragem;
  }

  instituicaoAdmAcesso() {
    return this.http
    .get<any>(this.baseUrl + '/oracao/get-instituicao-adm-acesso')
    .map((data) => {
      return data;
    });
  }

  getInstituicoesVinculadas() {
    return this.http
      .get<IListInstituicao[]>(this.baseUrl + '/oracao/get-instituicoes-vinculadas-adm-oracao', {
        observe: 'response'
      })
      .map((data) => {
        return data.body;
      });
  }

  isConfiguracaoSede() {
    return this.http.get<any>(this.baseUrl + '/oracao/get-is-configuracao-sede').map((data) => {
      return !data.error ?  data : false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/oracao/oracao.ts